module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/music-note-320c6741bd767524313952fea942e7cd.svg";